<template>
	<div class="container-fluid">
		<div class="row">
			<section id="tw-view-404" class="flex-grow-1">
				<div class="bg-white">
					<div class="p-4 py-5 my-5">
						<div class="d-flex justify-content-center mt-5">
							<h2 class="display-1"><b>404</b></h2>
						</div>
						<div class="d-flex justify-content-center mb-5">
							<h4>Not Found</h4>
						</div>
						<div class="d-flex justify-content-center my-5 py-5">
							<img src="@/assets/images/404.svg" width="40%" alt="" />
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Page404',
		components: {

		},
		data: () => ({

		}),
		mounted() {
			const path = this.$route.fullPath;
			history.replaceState(null, null, path);
		},
		methods: {

		},
		mixins: []
    }
</script>